import { render, staticRenderFns } from "./QuestionScoresSlide.vue?vue&type=template&id=51388097&scoped=true&"
import script from "./QuestionScoresSlide.vue?vue&type=script&lang=js&"
export * from "./QuestionScoresSlide.vue?vue&type=script&lang=js&"
import style0 from "./QuestionScoresSlide.vue?vue&type=style&index=0&id=51388097&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51388097",
  null
  
)

export default component.exports